import React, { Component } from "react";
// import {MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem,  MDBNavbarToggler, MDBCollapse, MDBFormInline, MDBNavLink} from "mdbreact";
import { Link } from "react-router-dom";
// import {Link} from 'react-router-dom'
import { Menu } from "semantic-ui-react";
// import {Container} from 'semantic-ui-react'

import Footer from "../../Footer";
import menus from "../Helpers/menus";
import {withRouter} from 'react-router'
import HeaderCommon from "../../HeaderCommon";
import decode from "jwt-decode";
import {
  Navbar,
  NavbarNav,
  NavbarToggler,
  Collapse,
  NavItem,
  NavLink,
  Button,
} from "mdbreact";
import { AuthConsumer } from "../../AuthContext";
import info from '../../info.png'
class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      isWideEnough: false,
      dropdownOpenAbout: false,
      dropdownOpenTeams: false,
      dropdownOpenProjects: false,
      active:props.match.url==='/webgis-snow'?'Snow Home':props.match.url==='/webgis-snow/map'?'Snow Geoportal':props.match.url==='/webgis-snow/proj-obj'?'Objective':null,
      isOpen: false,
      snowmodal:true
    };
  }

  toggle=()=>{
    this.setState({
      snowmodal:!this.state.snowmodal
    })
  }
  onClick = () => {
    this.setState({
      collapse: !this.state.collapse,
    });
  };
  _handleClick(menuItem) {
    this.setState({ active: menuItem });
    this.onClick()
  }
  componentDidUpdate(prevProps,prevState)
  {
    if(this.props.match.url!==prevProps.match.url)
    {
     this.setState({
      active:this.props.match.url==='/webgis-snow'?'Snow Home':this.props.match.url==='/webgis-snow/map'?'Snow Geoportal':this.props.match.url==='/webgis-snow/proj-obj'?'Snow Swipe':this.props.match.url==='/webgis-snow/swipe'?'Objective':null,
     })
    }
  }
  render() {
    const activeStyle = { color: "#ff3333" };
    let menuList = menus.head.map((menu, key) => {
      return (
        <NavItem key={key}>
          <NavLink to={menu.path} key={key}>
            <Menu.Item
              name={menu.name}
              style={this.state.active === menu.name ? activeStyle : {}}
              onClick={this._handleClick.bind(this, menu.name)}
            />
          </NavLink>
        </NavItem>
      );
    });
    const childrenWithExtraProp = React.Children.map(
      this.props.children,
      (child, i) => {
        return React.cloneElement(child, {
        //this properties are available as a props in child components
         snowmodal:this.state.snowmodal,
          toggle: this.toggle,
          index: i
        });
      }
    );
    return (
      <div className="wrapper">
        <HeaderCommon
          title=" Himalayan Snow Cover  Information System"
          screentitle="Snowmelt Runoff"
          bhuvanlink={true}
        />
        <Navbar dark expand="md" style={{ backgroundColor: "#026670" }}>
          {!this.state.isWideEnough && <NavbarToggler onClick={this.onClick} />}
          <Collapse isOpen={this.state.collapse} navbar>
            <NavbarNav left>{menuList}</NavbarNav>
            <NavbarNav right>
              <NavItem>
                <NavLink to="/webgis-snow/map">
                  <Menu.Item
                    name="Snow Geoportal"
                    style={
                      this.state.active === "Snow Geoportal" ? activeStyle : {}
                    }
                    onClick={this._handleClick.bind(this, "Snow Geoportal")}
                  />
                </NavLink>
              </NavItem>
              {!this.state.snowmodal?<NavItem className="content"><img src={info}  style={{ width: "20px", height: "20px", cursor: "pointer" }}  onClick={this.toggle}/></NavItem> :null}
            </NavbarNav>
            {/* <AuthConsumer>
                            {({ isAuth, logout }) => (
                                <NavbarNav right>
                                    {(isAuth) || (localStorage.getItem("token") !== null) ? (
                                        <NavbarNav right>
                                            <NavItem>
                                                {decode(localStorage.getItem('token')).trainee === 'trainee' ? <Button className="btn-sm" outline color="yellow" >Welcome {decode(localStorage.getItem('token')).name}</Button> :
                                                    <Link to={`/profile/${decode(localStorage.getItem('token')).id}`}><Button className="btn-sm" outline color="yellow" >Welcome {decode(localStorage.getItem('token')).name}</Button></Link>
                                                }           </NavItem>
                                            <NavItem><Button className="btn-sm" onClick={logout}>logout</Button></NavItem>
                                        </NavbarNav>
                                    ) : (
                                            <NavbarNav right>
                                                <NavItem>
                                                    <NavLink to="/login">Login</NavLink>

                                                </NavItem>

                                            </NavbarNav>



                                        )}

                                </NavbarNav>
                            )}
                        </AuthConsumer> */}
          </Collapse>
        </Navbar>

        <div className="main">{childrenWithExtraProp}</div>

        <Footer />
      </div>
    );
  }
}

export default withRouter(Layout);
